<template>
    <div class="grow flex flex-col justify-center">
        <div v-if="data">
            <canvas ref="canvas" :data="data" :width="width" :height="height"></canvas>
        </div>
        <div class="px-5 pt-2 pb-6">
            <ul ref="legend" class="flex flex-wrap justify-center -m-1"></ul>
        </div>
    </div>
</template>

<script>
import { onMounted, onUnmounted, ref } from 'vue'
import { ArcElement, Chart, DoughnutController, TimeScale, Tooltip, } from 'chart.js'
import 'chartjs-adapter-date-fns'

// Import utilities

Chart.register(DoughnutController, ArcElement, TimeScale, Tooltip)

export default {
    name: 'DoughnutChart',
    props: ['data', 'width', 'height'],
    data() {
        return {
            ready: false,
        }
    },
    setup(props) {

        const canvas = ref(null)
        const legend = ref(null)
        let chart = null

        onMounted(() => {
            const ctx = canvas.value
            chart = new Chart(ctx, {
                type: 'doughnut',
                data: props.data,
                options: {
                    cutout: '80%',
                    layout: {
                        padding: 24,
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    return context.label + ': ' + context.raw + '%'
                                }
                            }
                        }
                    },
                    interaction: {
                        intersect: false,
                        mode: 'nearest',
                    },
                    animation: {
                        duration: 500,
                    },
                    maintainAspectRatio: false,
                    resizeDelay: 200,
                },
            })
        })

        onUnmounted(() => chart.destroy())

        return {
            canvas,
            legend,
        }
    }
}
</script>
